<template>
    <v-dialog
        v-model="visible"
        :show="true"
        persistent
        :max-width="510"
        overlay-color="#2c2c38"
        :overlay-opacity="0.8"
    >
        <v-card class="offline-too-long">
            <v-card-title class="offline-too-long-heading error">
                {{ $t('connection.internet_offline_too_long') }}
                <v-spacer />
                <div class="hidden-container" @click="hiddenClick"></div>
            </v-card-title>

            <v-card-text class="offline-too-long-content">
                <v-alert
                    class="offline-too-long-alert"
                    prominent
                    type="error"
                    text
                >
                    {{ $t('connection.internet_offline_too_long_message') }}
                </v-alert>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
const OFFLINE_FROM_KEY = 'offline-from';

export default {
    created() {
        this.eventBus.$on('show-offline-too-long', this.showOfflineTooLong);
    },

    beforeDestroy() {
        this.eventBus.$off('show-offline-too-long', this.showOfflineTooLong);
    },

    data() {
        return {
            visible: false,
            hiddenClickCount: 0,
            hiddenClickTimeout: null,
        };
    },

    watch: {
        isOnline(val, oldVal) {
            if(val) {
                this.hide()
            }
        }
    },

    methods: {
        showOfflineTooLong() {
            this.visible = true;
        },

        hide() {
            this.visible = false;
        },

        hiddenClick() {
            this.hiddenClickCount++;
            if(this.hiddenClickCount === 15) {
                this.hiddenAction()

                this.hiddenClickCount = 0
                clearTimeout(this.hiddenClickTimeout)
                return
            }

            clearTimeout(this.hiddenClickTimeout)
            this.hiddenClickTimeout = setTimeout(() => {
                this.hiddenClickCount = 0
            }, 2500)
        },

        hiddenAction() {
            this.hide()
            AppStorage.local().deleteItem(OFFLINE_FROM_KEY)
        }
    }
};
</script>

<style lang="scss" scoped>
.offline-too-long {
    display: flex;
    flex-direction: column;

    .offline-too-long-heading {
        color: white;
        justify-content: center;
        font-weight: 400;
        font-size: 22px;
        padding: 12px;

        .hidden-container {
            height: 32px;
            width: 50px;
        }
    }

    .offline-too-long-content {
        padding: 24px;

        .offline-too-long-alert {
            color: black !important;
            border: 1px solid #e8e8e8;

            &:before {
                background: #cccccc !important;
            }
        }
    }
}
</style>
